import React, { useState } from 'react';
import { Card, Tabs, Tab, Box } from '@mui/material';
import ArgonBox from 'components/ArgonBox';
import ArgonTypography from 'components/ArgonTypography';
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import Footer from 'examples/Footer';
import companyInfo from 'context/companyInfo';
import RCCustomObjectsView from './components/RCCustomObjectsView';

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div role="tabpanel" hidden={value !== index} {...other}>
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

function CustomObjects() {
  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <ArgonBox py={3}>
        <Card>
          <ArgonBox p={2}>
            <ArgonTypography variant="h5">Custom Objects</ArgonTypography>
          </ArgonBox>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <Tabs value={activeTab} onChange={handleTabChange} aria-label="custom objects tabs">
              <Tab label="RC Objects" />
              <Tab label="CPQ Objects" disabled /> {/* Disabled for now */}
            </Tabs>
          </Box>
          <TabPanel value={activeTab} index={0}>
            <RCCustomObjectsView />
          </TabPanel>
          <TabPanel value={activeTab} index={1}>
            {/* Placeholder for the future CPQ component */}
            <ArgonTypography>CPQ Custom Objects feature coming soon.</ArgonTypography>
          </TabPanel>
        </Card>
      </ArgonBox>
      <Footer company={companyInfo} links={companyInfo.links} />
    </DashboardLayout>
  );
}

export default CustomObjects;
